<template>
  <div class="product-recommanded row">
    <h2 class="text-center title-prod mb-5">{{ $t("reste_product_gamme.title") }}</h2>
    <div class="col col-lg-11 col-md-11 col-sm-11">
      <div class="carousel__wrapper" v-if="isReady">
        <Carousel ref="carousel" :key="carouselKey" v-bind="carouselConfig">
          <Slide v-for="product in ProductsRec" :key="product.id">
            <ProductCardSlide :product="product" />
          </Slide>

          <template #addons>
            <Navigation />
          </template>
        </Carousel>
      </div>
    </div>
  </div>
</template>

<script>
  import ProductCardSlide from "./ProductCardSlide.vue";
  import "vue3-carousel/carousel.css";
  import { Carousel, Slide, Navigation } from "vue3-carousel";

  export default {
    name: "ProductRecommanded",
    components: {
      ProductCardSlide,
      Carousel,
      Slide,
      Navigation,
    },
    props: {
      ProductsRec: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        carouselKey: 0,
        isReady: false,
      };
    },
    computed: {
      carouselConfig() {
        const shouldLoop = (this.ProductsRec || []).length >= 4;
        return {
          height: "100%",
          itemsToShow: 3,
          gap: 40,
          snapAlign: "start",
          autoplay: 60000,
          autoplayHoverPause: true,
          loop: shouldLoop,
          wrapAround: shouldLoop,
          pauseAutoplayOnHover: true,
          breakpointMode: "carousel",
          modelValue: 0,
          transition: 600,
          breakpoints: {
            0: {
              itemsToShow: 1,
              snapAlign: "start",
              loop: shouldLoop,
              wrapAround: shouldLoop,
            },
            400: {
              itemsToShow: 2,
              snapAlign: "start",
              loop: shouldLoop,
              wrapAround: shouldLoop,
            },
            600: {
              itemsToShow: 2,
              snapAlign: "start",
              loop: shouldLoop,
              wrapAround: shouldLoop,
            },
            992: {
              itemsToShow: 4,
              snapAlign: "start",
              loop: shouldLoop,
              wrapAround: shouldLoop,
            },
          },
        };
      },
    },
    watch: {
      ProductsRec: {
        handler() {
          this.carouselKey += 1;
          this.initializeCarousel();
        },
        immediate: true,
      },
    },
    mounted() {
      this.initializeCarousel();
    },
    methods: {
      initializeCarousel() {
        this.isReady = false;
        this.$nextTick(() => {
          setTimeout(() => {
            this.isReady = true;
            // Force le reset de la position après un délai
            this.$nextTick(() => {
              this.resetCarouselPosition();
            });
          }, 100);
        });
      },
      resetCarouselPosition() {
        setTimeout(() => {
          const carousel = this.$refs.carousel;
          if (carousel) {
            carousel.slideTo(0);
          }
        }, 200);
      },
    },
  };
</script>

<style scoped>
  .product-recommanded {
    gap: 10px;
    margin-top: 20px;
    justify-content: center;
  }
  .title-prod {
    color: #1e347d;
    font-weight: 900;
    line-height: 55px;
    font-size: 45px;
    font-style: normal;
    justify-content: center;
  }
  @media (max-width: 768px) {
    .title-prod {
      font-size: 14px;
      line-height: 30px;
    }
  }

  .carousel {
    --vc-nav-background: rgba(255, 255, 255, 0.7);
    --vc-nav-border-radius: 100%;
  }
  .carousel__wrapper {
    padding: 2px;
    position: relative;
    margin: 0 auto;
    /* overflow: hidden; */
  }

  :deep(.carousel__track) {
    transform: translateX(0) !important;
    transition: none !important;
  }

  :deep(.carousel__viewport) {
    overflow: hidden;
  }

  :deep(.carousel__slide:first-child) {
    margin-left: 0 !important;
  }
  :deep(.carousel__icon) {
    fill: #1e347d;
    height: 70%;
  }
  :deep(.carousel__next),
  :deep(.carousel__prev) {
    top: 38%;
    border: 1px solid #1e347d !important;
    background: #eff1f7;
  }
  :deep(.carousel__next:hover),
  :deep(.carousel__prev:hover) {
    background: #c9cfde;
  }
  :deep(.carousel__prev) {
    left: -4% !important;
  }
  :deep(.carousel__next) {
    right: -4% !important;
  }

  :deep(.carousel__slide) {
    display: flex;
    justify-content: center;
  }
</style>
